(function ($) {
  'use strict';

  Drupal.behaviors.viewsScrollOff = {
    attach: function () {
      /* Views Ajax Content Load Autoscroll Feature Disabled */
      Drupal.AjaxCommands.prototype.viewsScrollTop = null;
    }
  };
  
  Drupal.behaviors.scrollbarCheck = {
    attach: function (context, settings) {
      // Check if the vertical scrollbar is present
      function hasVerticalScrollBar() {
        return window.innerWidth > document.documentElement.clientWidth;
      }

      // If scrollbar is present, add class to body
      if (hasVerticalScrollBar()) {
        document.body.classList.add('has-vertical-scrollbar');
      }
    }
  };

  // Fixed header position tweaks when logged in with admin-toolbar
  Drupal.behaviors.pageHeaderToolbarTweaks = {
    attach: function(context, settings) {
      $('#toolbar-administration', context).once('toolbar-header-tweaks').each(function () {
        var $toolbar = $(this);
        var $body = $('body');
        var $header = $('#page__header');

        var bodyPaddingTop = $body.css('padding-top');
        $header.css('top', bodyPaddingTop);

        setTimeout(function() {
          bodyPaddingTop = $body.css('padding-top');
          $header.css('top', bodyPaddingTop);
        }, 1);

        $toolbar.find('a').on('click', function (e){
          setTimeout(function() {
            bodyPaddingTop = $body.css('padding-top');
            $header.css('top', bodyPaddingTop);
          }, 1);
        });

      });
    }
  }


  // Add scrolled class when scrolled 
  Drupal.behaviors.scrollCheck = {
    attach: function(context, settings) {
      $('#page__header', context).once('scroll-check').each(function () {
        var $headerWrapper = $(this);
        var $headerPlaceHolder = $('#page__header-placeholder');
        var $body = $('body');
        var scrollDirection;
        var previousScrollFromTop = 0;
        var currentScrollFromTop = 0;

        $(window).on('scroll', function() {

          currentScrollFromTop = $(window).scrollTop();

          if(currentScrollFromTop > previousScrollFromTop && currentScrollFromTop > $headerPlaceHolder.height()) {
            scrollDirection = 'down';
          } else {
            scrollDirection = 'up';
          }

          if(currentScrollFromTop > $headerPlaceHolder.height()) {
            $body.addClass('at-top');
          } else {
            $body.removeClass('at-top');
          }

          if(scrollDirection == 'down') {
            $body.removeClass('scrolled--up');
            $body.addClass('scrolled scrolled--down');
            $body.addClass('not-at-top');
          } 
          
          if(scrollDirection == 'up') {
            $body.removeClass('scrolled--down');
            $body.addClass('scrolled scrolled--up');
            $body.removeClass('not-at-top');
          }

          previousScrollFromTop = currentScrollFromTop;

        });
        

      });
    }
  }

  // Toggle mobile navigation
  Drupal.behaviors.toggleMobileNavigation = {
    attach: function(context, settings) {
      $('#js-mobile-menu-trigger', context).once('toggle-mobile-navigation').each(function () {
        var $toggleButton = $(this);
        var $body = $('body');
        $toggleButton.on('click', function() {
          $body.toggleClass('mobile-navigation-expanded');
          $toggleButton.find('.label').text(function(i, text){
            return text === "Menu" ? "Sluit" : "Menu";
          })
        });
      });
    }
  }


  // Add class depending on state of the cookie popup

  Drupal.behaviors.cookiePopupState = {
    attach: function(context, settings) {
      $('body', context).once('cookie-popup-state').each(function () {
        var $body = $('body');
        var $cookiePopup;
        var $cookieWithdrawTab;
        var initialCookiePopupCheck = setInterval(function() {
          $cookiePopup = $('#sliding-popup.sliding-popup-bottom');
          if($cookiePopup != 'undefined' && $cookiePopup.css('bottom') == '0px') {
            $body.addClass('privacy-popup-open');
            $cookieWithdrawTab = $('.eu-cookie-withdraw-tab');
            $cookieWithdrawTab.on('click', function() {
              console.log('toggle popup shadow');
              $('body').toggleClass('privacy-popup-open');
            });
            clearInterval(initialCookiePopupCheck);
          }
        }, 100);

      });
    }
  }

  // Custom privacy popup trigger for mobile because the default setup messes up the design
  Drupal.behaviors.mobilePrivacyPopupFix = {
    attach: function(context, settings) {
      $('.js-mobile-privacy-popup-trigger', context).once('mobile-privacy-popup-trigger').each(function () {
        var $privacyTrigger = $(this).find('a');
        $privacyTrigger.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var $cookieWithdrawTab = $('.eu-cookie-withdraw-tab');
          $cookieWithdrawTab.trigger('click');
        });
      });
    }
  }

  // Add security that the user can hide the cookiepopup by clikcing anywhere else 
  Drupal.behaviors.hidePrivacyPopupByClickingOutSideIt = {
    attach: function(context, settings) {
      $('#site-wrapper', context).once('site-get-out-of-cookie-popup').each(function () {
        var $siteWrapper = $(this);
        $siteWrapper.on('click', function() {
          if($('body').hasClass('privacy-popup-open')) {
            var $cookieWithdrawTab = $('.eu-cookie-withdraw-tab');
            $cookieWithdrawTab.trigger('click');
          }
        });
      });
    }
  }

  // Expandable Lists
  Drupal.behaviors.expandableList = {
    attach: function (context, settings) {
      const listItems = context.querySelectorAll('.expandable-list-item');
      
      listItems.forEach((listItem) => {
        // Prevent re-attachment with `once` check
        if (!listItem.classList.contains('expandable-list-processed')) {
          listItem.classList.add('expandable-list-processed');

          const listItemHead = listItem.querySelector('.expand-trigger');
          const listItemContent = listItem.querySelector('.expand-content');

          listItemContent.style.display = 'none';

          listItemHead.addEventListener('click', function () {
            // Toggle visibility
            if (listItemContent.style.display === 'none') {
              listItemContent.style.display = 'block';
              listItem.classList.add('active'); // Add active class on expand
            } else {
              listItemContent.style.display = 'none';
              listItem.classList.remove('active'); // Remove active class on collapse
            }
          });
        }
      });
    }
  };


}(jQuery));